module.exports = __webpack_public_path__ + "static/media/reply-all.00363b38.svg";